/* @generated */
import * as React from "react";
import { contentIconRecipe } from "../styles/index.css.esm.js";
import classNames from "classnames";
import { useThemedStyle } from "../hooks/useThemedStyle.esm.js";
import { BackgroundFileSmall } from "./_background/background-file-small.esm.js";
import { useCompositeContentIconViewBox } from "../hooks/useContentIconViewbox.esm.js";
const FileWordSmall = ({
  className,
  hasWhitespace = true,
  over = "base",
  hasBackground = true,
  ...props
}) => {
  const cls = classNames([
    "dig-ContentIcon",
    className,
    "dig-ContentIcon--small",
    {
      "dig-ContentIcon--overBase": over === "base",
      "dig-ContentIcon--overSubtle": over === "subtle",
      "dig-ContentIcon--hasNoBackground": !hasBackground
    },
    contentIconRecipe({ over, hasNoBackground: !hasBackground })
  ]);
  const style = useThemedStyle({ over });
  const viewBox = useCompositeContentIconViewBox({ hasWhitespace, size: "small" });
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      viewBox,
      fill: "none",
      role: "presentation",
      focusable: "false",
      width: 40,
      height: 40,
      className: cls,
      "data-testid": "FileWordSmall",
      style,
      ...props
    },
    hasBackground ? /* @__PURE__ */ React.createElement(BackgroundFileSmall, null) : null,
    /* @__PURE__ */ React.createElement("path", { d: "m7 8 7-1v11.333l-7-1V8Z", fill: "#2B579A" }),
    /* @__PURE__ */ React.createElement("path", { d: "M13.334 8H18.7a.3.3 0 0 1 .3.3v8.733a.3.3 0 0 1-.3.3h-5.366V8Z", fill: "#2B579A" }),
    /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M14 8.666h4.333v8H14z" }),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#2B579A",
        d: "M13.666 9.667h3.667v.667h-3.667zm0 1.999h3.668V11h-3.668zM13.334 13h4v-.667h-4zm0 1.333h4v-.667h-4zm.332 1.334h3.668V15h-3.668z"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "m13 10.667-.937 4h-.886L10.59 12.1a2.399 2.399 0 0 1-.057-.45h-.01a3.064 3.064 0 0 1-.064.45l-.603 2.566h-.923l-.932-4h.873l.5 2.664c.02.113.037.266.046.457h.015c.007-.143.03-.3.072-.469l.643-2.652h.856l.58 2.686c.022.098.04.242.057.43h.01a3.22 3.22 0 0 1 .052-.447l.49-2.67H13Z",
        fill: "#fff"
      }
    )
  );
};
export {
  FileWordSmall
};
